import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ArrowLeft, ArrowRight } from "react-feather";
import BreadCrumbs from "@components/breadcrumbs/index1";
import "./_quizItem.css";
// ** Third Party Components
import Chart from "react-apexcharts";
import {
  _getAnswersByQuizID,
  _getQuizById,
  _AnswerQuizAction
} from "../../../../../redux/action/quizz/QuizzAction";
// ** Reactstrap Imports
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  CardSubtitle,
  Button
} from "reactstrap";
import { useState } from "react";
import OptionsForm from "./OptionsForm";
import { useEffect } from "react";
const QuizItem = (props) => {
  const [answer, setAnswers] = useState({});
  const dispatch = useDispatch();
  const quiz_id = props.match.params.id;
  var quiz = useSelector((store) => store?.QuizzReducer?._getQuizByID);

  quiz._answers = quiz._answers.sort((a, b) => a.id - b.id);
  useEffect(() => {
    _getQuizById(dispatch, quiz_id);

    return () => {
      _getQuizById(dispatch, quiz_id);
    };
  }, []);

  const { t } = useTranslation();
  const lastselectedRadioIndex = useSelector(
    (store) => store?.QuizzReducer?._QuizFormLastselectedIndex
  );


  // theme dark mode info
  const FrontofficeThemeReducer = useSelector(
    (state) => state.FrontofficeThemeReducer
  );
  const themeStore = FrontofficeThemeReducer;
  const tempalte = themeStore?.design_by_radio?.templates.id;


  const donutColors = {
    series1: "#ffe700",
    series2: "#00d4bd",
    series3: "#826bf8",
    series4: "#2b9bf4",
    series5: "#FFA1A1"
  };

  // ** Chart Options
  const options = {
    legend: {
      show: true,
      position: "bottom"
    },
    labels: quiz?._answers?.map((ele) => ele.opt_text),

    colors: [
      donutColors.series1,
      donutColors.series5,
      donutColors.series3,
      donutColors.series2
    ],
    dataLabels: {
      enabled: true,
      formatter(val) {
        return `${parseInt(val)}%`;
      }
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            name: {
              fontSize: "2rem",
              fontFamily: "Montserrat"
            },
            value: {
              fontSize: "1rem",
              fontFamily: "Montserrat",
              formatter(val) {
                return `${parseInt(val)} vote`;
              }
            },
            total: {
              show: true,
              fontSize: "1.5rem",
              label: "total",
              formatter() {
                return `${quiz.sumVotes} votes`;
              }
            }
          }
        }
      }
    },
    responsive: [
      {
        breakpoint: 992,
        options: {
          chart: {
            height: 380
          },
          legend: {
            position: "bottom"
          }
        }
      },
      {
        breakpoint: 576,
        options: {
          chart: {
            height: 320
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  name: {
                    fontSize: "1.5rem"
                  },
                  value: {
                    fontSize: "1rem"
                  },
                  total: {
                    fontSize: "1.5rem"
                  }
                }
              }
            }
          }
        }
      }
    ]
  };

  // ** Chart Series

  const series = quiz?._answers?.map((ele) => ele.AnswersCount);

  //change handlers section
  const handelOptionSelect = (e, index) => {

    if (e.target.type === "checkbox") {
      if (e.target.checked) {
        quiz._answers[index].AnswersCount =
          quiz._answers[index].AnswersCount + 1;
        quiz.sumVotes = quiz.sumVotes + 1;
        dispatch({ type: "_GET_QUIZ_BY_ID", data: quiz });
      } else {
        quiz._answers[index].AnswersCount =
          quiz._answers[index].AnswersCount - 1;
        quiz.sumVotes = quiz.sumVotes - 1;
        dispatch({ type: "_GET_QUIZ_BY_ID", data: quiz });
      }
    } else {
      if (lastselectedRadioIndex === -1) {
        quiz._answers[index].AnswersCount += 1;
        quiz.sumVotes = quiz.sumVotes + 1;

        dispatch({
          type: "UPDATE_LAST_SELECTED_FORM_INDEX",
          data: { index, quiz }
        });
      } else {
        quiz._answers[lastselectedRadioIndex].AnswersCount =
          quiz._answers[lastselectedRadioIndex].AnswersCount - 1;
        quiz._answers[index].AnswersCount =
          quiz._answers[index].AnswersCount + 1;

        dispatch({
          type: "UPDATE_LAST_SELECTED_FORM_INDEX",
          data: { index, quiz }
        });
      }
    }
  };

  //handel submit function

  const handelSubmit = () => {
    const updateDto = {
      quizCount: quiz.sumVotes,
      answersCount: quiz._answers.map((ele) => ({
        id: ele.id,
        count: ele.AnswersCount
      }))
    };
    _AnswerQuizAction(dispatch, quiz_id, updateDto,handelCanselVote);
    

  };

  //handel cancel vote
  const handelCanselVote = () => {
    _getQuizById(dispatch, quiz_id);
    let elements = document.getElementsByClassName("Quiz2Formelement");
    for (let i = 0; i < elements.length; i++) {
      elements[i].checked = false;
    }
  };

  return (
    <>
    {tempalte === 2 ? (
            <BreadCrumbs
            breadCrumbTitle={t("Quiz")}
          />
      ) : (
        <section className="single-banner">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="single-content">
                <h2>{t("Quiz")}</h2>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">{t("Home")}</Link>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
      )}
    

      <div className="_quizItemWrapper">
        <div style={{}}>
          <div
            className="d-flex p-1 border"
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignContent: "center",
              justifyContent: "center"
            }}
          >
            <h3>{quiz.title}</h3>
            <OptionsForm
              multiChoice={quiz.multiChoice}
              sum={quiz.sumVotes}
              j={0}
              optionsData={quiz._answers.filter((ele) => ele.status)}
              handelOptionSelect={handelOptionSelect}
              progresbarChart={quiz.progresbarChart}
            />
            <div className="buttons_wrapper">
              <Button
                color="warning"
                onClick={handelCanselVote}
                className="btn-prev"
                outline
              >
                <ArrowLeft
                  size={14}
                  className="align-middle me-sm-25 me-0"
                ></ArrowLeft>
                <span className="align-middle d-sm-inline-block d-none">
                  {t("cancel")}
                </span>
              </Button>
              <Button
                type="submit"
                onClick={handelSubmit}
                color="success"
                className="btn-next"
              >
                <span className="align-middle d-sm-inline-block d-none">
                  {t("Submit")}
                </span>
                <ArrowRight
                  size={14}
                  className="align-middle ms-sm-25 ms-0"
                ></ArrowRight>
              </Button>
            </div>
          </div>
        </div>
        {quiz.donutChart ? (
    

              <Chart
                options={{ ...options }}
                series={series}
                type="donut" 
              
                
                height={350} 
              />

    
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default QuizItem;
